import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";

const resolveSrc = (url) => (url && url.startsWith("http") ? url : url ? `${API}/files/${url}` : "");

// placement: "landing" | "customer_dashboard" | "collector_dashboard"
export const AdSlot = ({ placement, zip, services, className = "" }) => {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    const params = { placement };
    if (zip) params.zip = zip;
    if (services && services.length) params.services = services.join(",");
    api.get("/ads", { params }).then(({ data }) => setAds(data || [])).catch(() => {});
  }, [placement, zip, services]);

  if (!ads.length) return null;

  const onClick = (ad) => {
    api.post(`/ads/${ad.id}/click`).catch(() => {});
  };

  return (
    <div className={`space-y-4 ${className}`} data-testid={`ad-slot-${placement}`}>
      {ads.map((ad) => {
        const src = resolveSrc(ad.image_url);
        return (
          <a
            key={ad.id}
            href={ad.link_url || "#"}
            target={ad.link_url ? "_blank" : undefined}
            rel="noreferrer sponsored"
            onClick={() => onClick(ad)}
            data-testid={`ad-${ad.id}`}
            className="block rounded-2xl border border-[#1E3F33]/10 bg-white overflow-hidden hover:shadow-md transition-shadow"
          >
            {src && <img src={src} alt={ad.headline || ad.title} className="w-full h-40 object-cover" loading="lazy" />}
            <div className="p-4">
              <span className="text-[10px] uppercase tracking-[0.18em] text-[#8A9A86]">Sponsored</span>
              {ad.headline && <h3 className="font-heading text-lg text-[#1E3F33] mt-1">{ad.headline}</h3>}
              {ad.body && <p className="text-sm text-[#5C6B64] mt-1">{ad.body}</p>}
              {ad.link_url && <span className="inline-block mt-3 text-sm font-medium text-[#CC5A3A]">{ad.cta_label || "Learn more"} →</span>}
            </div>
          </a>
        );
      })}
    </div>
  );
};
